import { render } from "./RoleBadge.vue?vue&type=template&id=b2cd7ee8&scoped=true"
import script from "./RoleBadge.vue?vue&type=script&lang=js"
export * from "./RoleBadge.vue?vue&type=script&lang=js"

import "./RoleBadge.vue?vue&type=style&index=0&id=b2cd7ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2cd7ee8"]])

export default __exports__